import { useState } from "react"
import { FamilyVariant, Tab } from "../../../types/AlgoliaTypes";

import { lowercaseAndUnderscore } from "../../../utils/utils";
import TabsModal from "../../TabsModal/TabsModal";

interface TabsProps {
    tabData: Tab[];
    pressureType?: string;
    currentLaminate?: string;
    isLaminate?: boolean;
    isHighAbrasion?: boolean;
    variants?: FamilyVariant[]
    callbackOnClick: (tabTitle: string) => boolean
}
export default function Tabs({ tabData, callbackOnClick, isHighAbrasion }:TabsProps) {
    const [activeTab, setActiveTab] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const handleTabClick = (tabIndex: number, tabTitle: string) => {
        const laminate = callbackOnClick(tabTitle)
        if(!laminate) {
            setActiveTab(tabIndex);
        }
    }

    const isActive = (tabIndex: number, className: string) => activeTab === tabIndex ? className : "";

    const handleClickOnInfoIcon = (tabTitle: string) => setIsModalOpen(true);
   
    return (
        <>
            {/* <TabsModal isOpen={isModalOpen} setIsOpen={() => setIsModalOpen(!isModalOpen)} content={getModalContent()}/> */}
            <div className={"finish-details__tabs-container"}>
                {
                    
                    tabData.map((tab, idx) => {
                        let tabTitle = tab.tabTitle

                        if(window.steelcase_i18n["steelcase-finish-library"].nav && window.steelcase_i18n["steelcase-finish-library"].nav.overview_upholstery && tab.tabTitle === "Overview") {
                            tabTitle = window.steelcase_i18n["steelcase-finish-library"].nav.overview_upholstery 
                        }

                        if(window.steelcase_i18n["steelcase-finish-library"].characteristics_upholstery && tab.tabTitle === "Characteristics") {
                            tabTitle = window.steelcase_i18n["steelcase-finish-library"].characteristics_upholstery
                        }

                        return (
                            <button 
                                className={isActive(idx, "active")} 
                                onClick={() => handleTabClick(idx, tabTitle)} 
                                key={idx}
                            >
                                {tabTitle}
                            </button>
                        )
                    })

                }
               
            </div>
            <div className={"finish-details__tabs-data"}>
                {
                    tabData.map((tab, idx) => {
                        return (
                            <table className={isActive(idx, "active")} key={idx}>
                                <tbody>
                                    
                                        {
                                            tab.tabItems.map((item, idx) => {
                                                if(item.label === "Notes") {
                                                    var arr = item.value as string[]
                                                    if (arr.length === 0 || arr[0] === undefined || arr[0] === null) return null;
                                                }
                                                let measurementArr;
                                                if(item.label === "Weight" || item.label === "Width" || item.label === "Abrasion Wyzenbeek") {
                                                    measurementArr = item.value as string[]
                                                    if(measurementArr !== undefined && measurementArr !== null && measurementArr.length > 0 && measurementArr[1]) {
                                                        if(measurementArr[1] === "ounces per linear yard" && window.steelcase_finish_library.siteUrl.path.includes("eu")) {
                                                            return null;
                                                        }
                                                        if(measurementArr[1] === "inches" && window.steelcase_finish_library.siteUrl.path.includes("eu")) {
                                                            return null;
                                                        }
                                                        if(measurementArr[1] === "Double Rubs" && window.steelcase_finish_library.siteUrl.path.includes("eu")) {
                                                            return null;
                                                        }

                                                        if(measurementArr[1] === "centimeters" && window.steelcase_finish_library.siteUrl.path == "/") {
                                                            return null;
                                                        }

                                                        if(measurementArr[1] === "grams per linear meter" && window.steelcase_finish_library.siteUrl.path == "/") {
                                                            return null;
                                                        }

                                                        if(measurementArr[1] === "Martindale Cycles" && window.steelcase_finish_library.siteUrl.path == "/") {
                                                            return null;
                                                        }
                                                    }
                                                }

                                                if (item.label === "High Abrasion" && !isHighAbrasion) return null
                                                
                                                if (item.value[0] === null) return null
                                                return (
                                                    <tr 
                                                        key={idx} 
                                                        style={item.label === "ACT" && window.steelcase_finish_library.siteUrl.path.includes("eu") 
                                                            ? {display: "none"}
                                                            : {display: "table-row"}
                                                        }
                                                    >
                                                        <th>
                                                            <span>
                                                                {window.steelcase_i18n && window.steelcase_i18n['steelcase-finish-library'] &&
                                                                    window.steelcase_i18n['steelcase-finish-library'].tabs &&
                                                                    window.steelcase_i18n['steelcase-finish-library'].tabs[lowercaseAndUnderscore(item.label)] ? 
                                                                        window.steelcase_i18n['steelcase-finish-library'].tabs[lowercaseAndUnderscore(item.label)] : 
                                                                        item.label
                                                                }
                                                                {/* <i className={"finish-details__info-icon"} style={item.label === "ACT" ? { display: "inline-block" } : { display: "none" } } onClick={() => handleClickOnInfoIcon(item.label)}>&#9432;</i> */}
                                                            </span>
                                                        </th>
                                                        
                                                        <td className={`${item.label === "ACT" ? "finish-details__tabs-data--act-icon-flex" : ""}`}>
                                                        {
                                                            (() => {
                                                                if(item.label === "Brand" || item.label === "Global Availability" || item.label === "Material Type" || item.label === "Design" || item.label === "Application" || item.label === "Sustainability" || item.label === "Offering" || item.label === "Price" || item.label === "Flammability") {
                                                                    let arr = item.value as string[]
                                                                    return arr.join(", ")
                                                                } else if (item.label === "Notes") {        
                                                                    return <div dangerouslySetInnerHTML={{ __html: item.value as string }}></div>
                                                                } else if (item.label == "ACT") {
                                                                    let actIconPaths = item.value as string; 
                                                                    return actIconPaths.split(",").map((item, idx) => {
                                                                        return <span key={`${item}-${idx}`} className={`finish-details__tabs-data--act-icon finish-details__tabs-data--${item}`} />
                                                                    })
                                                                } else if (item.label === "Weight") {
                                                                    let arr = item.value as string[]
                                                                    arr[0] = (+arr[0]).toFixed(2).replace(/([0-9]+(\.[0-9]+[1-9])?)(\.?0+$)/,'$1')
                                                                    if(window.steelcase_finish_library.siteUrl.path.includes("eu")) {
                                                                        if(arr[1] === "grams per linear meter") {
                                                                            return arr.join(" ");
                                                                        }
                                                                    } else {
                                                                        return arr.join(" ");
                                                                    }
                                                                } else if (item.label === "Width") {
                                                                    let arr = item.value as string[]
                                                                    arr[0] = (+arr[0]).toFixed(2).replace(/([0-9]+(\.[0-9]+[1-9])?)(\.?0+$)/,'$1')
                                                                    if(window.steelcase_finish_library.siteUrl.path.includes("eu")) {
                                                                        if(arr[1] === "centimeters") {
                                                                            return arr.join(" ");
                                                                        }
                                                                    } else if(window.steelcase_finish_library.siteUrl.path == "/") {
                                                                        if(arr[1] === "inches") {
                                                                            return arr.join(" ");
                                                                        }
                                                                    }
                                                                    else {
                                                                        return arr.join(" ");
                                                                    }
                                                                } else if (item.label === "Abrasion Wyzenbeek") {
                                                                    let arr = item.value as string[]
                                                                    arr[0] = (+arr[0]).toFixed(2).replace(/([0-9]+(\.[0-9]+[1-9])?)(\.?0+$)/,'$1')
                                                                    if(window.steelcase_finish_library.siteUrl.path.includes("eu")) {
                                                                        if(arr[1] === "Martindale Cycles") {
                                                                            return arr.join(" ");
                                                                        }
                                                                    } else if(window.steelcase_finish_library.siteUrl.path == "/") {
                                                                        if(arr[1] === "Double Rubs") {
                                                                            return arr.join(" ");
                                                                        }
                                                                    } else {
                                                                        return arr.join(" ");
                                                                    }
                                                                } else if (item.label === "Horizontal Repeat" || item.label === "Vertical Repeat") {
                                                                   let val = (+item.value).toFixed(2).replace(/([0-9]+(\.[0-9]+[1-9])?)(\.?0+$)/,'$1') 
                                                                   return val;
                                                                } else if (item.label === "Sample Ordering" || item.label === "Collection") {
                                                                    let arr = item.value as string[] // 0 = text, 1 = link
                                                                    return <a href={arr[1]} target="_blank" rel="noopener noreferrer">{arr[0]}</a>
                                                                } else if (item.label === "Choice Performance") {
                                                                    let value = item.value as string
                                                                    return <a href={value} target="_blank" rel="noopener noreferrer">Yes</a>
                                                                } else if (item.label === "High Abrasion") {
                                                                    let arr = item.value as string[]
                                                                    return arr[0];
                                                                } else {
                                                                    return item.value
                                                                }
                                                            })()  
                                                        }
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    
                                </tbody>
                            </table>
                        )
                    })
                }
                
            </div>
        </>
    )
}